import React from 'react'
import {StatsTab} from "../StatsTab";
import {
  Col,
} from 'reactstrap';
import {TRANSLATED_PRODUCT_GROUP_TYPES} from "../../../../config/constants/ProductGroups";
import moment from 'moment';
import { FormattedMessage } from 'react-intl';

const ChartHeaders = (props) => {
  const {cardsData = {}, products = []} = props

  const toNumber = value => {
    const number = Number(value);
    return Number.isFinite(number) ? number : 0;
  };

  const monthComparison = (months, currentMonth, lastMonth) => {
    const current = toNumber(months[currentMonth]);
    const previous = toNumber(months[lastMonth]);
    const percentage = previous === 0 ? 0 : ((current - previous) / previous) * 100;

    return { current, percentage };
  };

  const renderHeaders = () => {
    const currentMonth = moment().format('YYYY-MM');
    const lastMonth = moment().subtract(1, 'months').format('YYYY-MM');
    const revenueByMonth = cardsData?.first?.dataset?.revenue?.byMonth;
    if (!revenueByMonth || typeof revenueByMonth !== 'object') {
      return null;
    }

    const revenue = monthComparison(revenueByMonth, currentMonth, lastMonth);
    const availableProducts = (Array.isArray(products) ? products : []).filter(product => (
      cardsData?.[product.id]?.dataset?.quantity?.byMonth
      && typeof cardsData[product.id].dataset.quantity.byMonth === 'object'
    ));

    return (
      <>
        <Col md="6" xl="3">
          <StatsTab
            title={<FormattedMessage id="components.pages.reports.totalThisMonth"/>}
            value={revenue.current.toFixed(2) + " RON"}
            percent={revenue.percentage.toFixed(2)}
            progressDescription={revenue.percentage === 0
              ? <FormattedMessage id="components.pages.reports.noInfoLastMonth"/>
              : <FormattedMessage id="components.pages.reports.sinceLastMonth"/>}
          >
            <div className="icon icon-shape bg-gradient-red text-white rounded-circle shadow">
              <i className="ni ni-active-40" />
            </div>
          </StatsTab>
        </Col>
          {
            availableProducts.map(product => {
              const quantityByMonth = cardsData[product.id].dataset.quantity.byMonth;
              const quantity = monthComparison(quantityByMonth, currentMonth, lastMonth);
              const total = Object.values(quantityByMonth).reduce((sum, value) => (
                sum + toNumber(value)
              ), 0);

              return (
                <Col md="6" xl="3" key={product.id}>
                <StatsTab
                  title={TRANSLATED_PRODUCT_GROUP_TYPES[product.name]}
                  value={total}
                  percent={quantity.percentage.toFixed(2)}
                  progressDescription={quantity.percentage === 0
                    ? <FormattedMessage id="components.pages.reports.noInfoLastMonth"/>
                    : <FormattedMessage id="components.pages.reports.sinceLastMonth"/>}
                >
                  <div className="icon icon-shape bg-gradient-red text-white rounded-circle shadow">
                    <i className="ni ni-active-40" />
                  </div>
                </StatsTab>
                </Col>
              )
            })
          }
      </>
    )
  }

  return (
    Object.keys(cardsData).length !== 0 &&
      renderHeaders()
  )
}

export { ChartHeaders }
